/* import __COLOCATED_TEMPLATE__ from './user-summary-users-list.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
